<template>
  <b-input-group>
    <b-form-input
      :id="id"
      type="number"
      :value="input_value"
      @input="handleInput"
    />
    <b-input-group-append>
      <b-input-group-text>%</b-input-group-text>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  props: {
    id: undefined,
    value: undefined,
  },
  data: function () {
    return {
      input_value: this.value * 100,
    };
  },
  methods: {
    handleInput(value) {
      var percentage = parseFloat(value) / 100;

      this.$emit("input", percentage);
    },
  },
};
</script>
